import { useTranslation } from 'react-i18next';
import { VerificationCountrySelectButton } from '@/components/VeriffCountrySelectButton';
import { SOURCES } from './constants';
import s from './index.module.scss';

export const VerifyForm = ({ source, onSuccess }) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        {source === SOURCES.registration && (
          <h1 className="f-headline-sm f-500">
            {t('veriff:verify_your_identity')}
          </h1>
        )}
        <div className="f-body-md">{t('veriff:safe_marketplace_message')}</div>
      </div>

      <div className={s.content}>
        <div className="f-body-sm">
          {t('veriff:start_verification_message')}
        </div>
        <ul className={s.list}>
          <li>
            <div className={s.number}>1</div>
            <div className="f-body-sm">
              {t('veriff:prepare_identity_document')}
            </div>
          </li>
          <li>
            <div className={s.number}>2</div>
            <div className="f-body-sm">{t('veriff:check_camera')}</div>
          </li>
          <li>
            <div className={s.number}>3</div>
            <div className="f-body-sm">
              {t('veriff:prepare_photo_and_selfie')}
            </div>
          </li>
        </ul>
        <VerificationCountrySelectButton onSuccess={onSuccess}  />
      </div>

      <div className={s.divider} />

      <div className={s.bottom}>
        <div className="f-body-xs">
          {t('veriff:identity_verification_provided_by_veriff')}
        </div>
        <div className="f-body-xs">{t('veriff:media_storage_message')}</div>
      </div>
    </div>
  );
};
